import React from 'react';
import BaseComponent, {AjaxParam} from '../common/BaseComponent/BaseComponent';
import {notify} from "../common/primitives/Notification/Notification";

const ContextDomainSearchResult = React.createContext({});

/**
 * @class ContextDomainSearchResultProvider
 * @property {DomainData} contextData
 * @property {array} takenTLDs Основни TLD-та които са заети.
 * @property {Function} getPrimaryDomainData Връща основноия домейн търсен с TLD. Търсеният от клиента
 * @property {Function} getNotCheckedOrFreeDomains Връща масив от домейни, които не са проверени или са свободни.
 * @property {Function} getNotSuggestedDomainData Връща домейн който не е алтернативен (domain_suggested = 0).
 *
 */
class ContextDomainSearchResultProvider extends BaseComponent {

	constructor(props) {

		super(props);
		this.componentName = SHVO.pageState.componentData.contextDomainSearchResultProvider.componentName;
		this.componentToken = SHVO.pageState.componentData.contextDomainSearchResultProvider.componentToken;

		this.state = {
			contextData: SHVO.pageState.componentData.contextDomainSearchResultProvider.componentData,
			takenTLDs: [],
			getPrimaryDomainData: this.getPrimaryDomainData,
			getNotCheckedOrFreeDomains: this.getNotCheckedOrFreeDomains,
			getNotSuggestedDomainData: this.getNotSuggestedDomainData,
		}
	}

	componentDidMount() {
		super.componentDidMount();
		this.checkDomains();
	}

	/**
	 * Връща основноия домейн търсен с TLD. Търсеният от клиента
	 * @returns {Array<DomainData>}
	 */
	getPrimaryDomainData = () => {
		const {contextData} = this.state;
		let notSuggestedDomains = [];
		let returnDomainsData = false;
		Object.keys(contextData).map((k) => {

			if (!contextData[k].domain_suggested) {
				notSuggestedDomains.push(contextData[k]);
			}

			if (contextData[k].searched_with_tld && contextData[k].is_checked) {
				returnDomainsData = true;
			}
		});
		return returnDomainsData ? notSuggestedDomains : [];
	};

	/**
	 * Връща домейн който не е алтернативен (domain_suggested = 0).
	 * @returns {Array<DomainData>}
	 */
	getNotSuggestedDomainData = () => {
		const {contextData} = this.state;
		let primaryDomain = [];
		Object.keys(contextData).map((k) => {
			if (!contextData[k].domain_suggested && contextData[k].is_checked) {
				primaryDomain[0] = contextData[k];
			}
		});
		return primaryDomain;
	};
	/**
	 * Връща масив от домейни, които не са проверени или са свободни.
	 * @returns {Array<DomainData>}
	 */
	getNotCheckedOrFreeDomains = () => {
		const {contextData} = this.state;
		let domains = [];
		Object.keys(contextData).map((k) => {
			if (contextData[k].is_checked === false || (contextData[k].is_free === 1 && contextData[k].searched_with_tld === 0)) {
				domains.push(contextData[k]);
			}
		});
		return domains;
	};

	checkDomains = () => {
		const {contextData} = this.state;
		const state = this.state;
		Object.keys(contextData).map((k) => {
			const domainData = contextData[k];
			const {
				is_checked,
				domain_name,
				domain_name_orig,
				is_free,
				domain_tld
			} = domainData;

			/**
			 * Дали домейна е вече проверен.
			 */
			if (is_checked) {
				if (domain_name === domain_name_orig) {
					if (domain_tld === 'com' || domain_tld === 'net' || domain_tld === 'eu' || domain_tld === 'bg' || domain_tld === 'org') {
						if (is_free === 0) {
							if (state.takenTLDs.indexOf(domain_tld) === -1) {
								state.takenTLDs.push(domain_tld);
								this.setState(state);
							}
						}
					}
				}
				return;
			}
			const ajaxParam = new AjaxParam();
			ajaxParam.callbackSuccess = (data) => {
				const domainData = data.componentData;
				const {
					id,
					domain_tld,
					domain_name,
					domain_name_orig,
					is_free
				} = domainData;
				state.contextData[id] = domainData;

				if (domain_name === domain_name_orig) {
					if (domain_tld === 'com' || domain_tld === 'net' || domain_tld === 'eu' || domain_tld === 'bg' || domain_tld === 'org') {
						if (is_free === 0) {
							if (state.takenTLDs.indexOf(domain_tld) === -1) {
								state.takenTLDs.push(domain_tld);
							}
						}
					}
				}
				this.setState(state);
			};
			ajaxParam.callbackError = (data) => {
				const {
					componentErrors
				} = data;
				const errorMessage = componentErrors[0];
				notify.error(this.messages[errorMessage] || errorMessage);

				domainData.is_checked = 1;
				domainData.is_free = 0;
				state.contextData[domainData.id] = domainData;
				this.setState(state);
			};
			ajaxParam.cypressParamString = '?ActionCheckDomain-' + domainData.domain_full;
			this.ajaxCall('ActionCheckDomain', domainData, ajaxParam);
		});
	};

	render() {
		return (
			<ContextDomainSearchResult.Provider value={this.state}>
				{this.props.children}
			</ContextDomainSearchResult.Provider>
		)
	}
}

export {ContextDomainSearchResult, ContextDomainSearchResultProvider};


/**
 * @typedef {Object} DomainData
 * @property {number} alreadyAddedToCart - Дали вече е добавен в количката.
 * @property {number} auto_add_to_cart - Автоматично добавяне в количката.
 * @property {string} bg_domain_similar - Използва се при двойките BG домейни. Съдържа името на домейна, койт е копие на този,
 * 										  но с различно TLD.
 * @property {string} cartLineId - Ако домейна е в количката, съдържа ID към реда от количката.
 * @property {number} domain_suggested - Дали домейна е алтернатива
 * @property {string} domain_full - Пълното име на домейна.
 * @property {string} domain_tld  - TLD на домейна
 * @property {string} domain_name - Име на домейн без TLD.
 * @property {string} domain_name_orig - Име на домейн без TLD. Това име е без промени. Каквото е въведено от клиента.
 * @property {bool} has_tags - Дали за домейна има тагове.
 * @property {string} id - md5 сума на пълното име на домейна.
 * @property {boolean} inCart - Дали домейна е в количката.
 * @property {number} isPremium - Дали домейна е premium.
 * @property {boolean} is_checked - Дали домейна е проверен.
 * @property {string} is_cyrillic - Дали домейна е на кирилица.
 * @property {number} is_free - Дали домейна е свободен.
 * @property {number} searched_with_tld - Дали домейна е търсен с TLD
 * @property {string} showBGDomainNotAllowedMessage - Дали да се показва съобщение за невалидно име на BG домейн.
 * @property {string} showBGDomainSavedMessage - Дали да се показва съобщение за запазен BG домейн.
 * @property {DomainTags} tags - Тагове на домейн.
 * @property {Array.<TLDLabelData>} labels - Label-и на tld-то на домейна.
 */

/**
 * @typedef {Object} DomainTags
 * @property {string} premium - premium.
 */
